import { useSuspenseQuery } from '@tanstack/react-query'
import { useParams } from 'react-router'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useDocumentFlags() {
  const documentKey = useParams<'documentKey'>().documentKey as string

  return useSuspenseQuery({
    ...apiClient.getDocumentFlagsDocumentsKeyFlagsGetOptions({
      path: { key: documentKey },
    }),
    staleTime: Infinity,
  })
}
